export default __webpack_public_path__ + "static/media/849ae2509d476fdb59b17fe3270ac762.1b7fc468.jpg";